import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import { Image as ImageIcon, InsertDriveFile as FileIcon } from '@mui/icons-material';
import { translate as t } from 'hooks/useTranslations';
import { Attachment } from '../../_types/manuals/draft';

interface AttachmentPreviewBoxProps {
  attachment?: Attachment | null;
  isLoading?: boolean;
  noImageText?: string;
  size?: number;
}

const AttachmentPreviewBox: React.FC<AttachmentPreviewBoxProps> = ({
  attachment,
  isLoading = false,
  noImageText = t('draftManuals.manualProperties.policyHeaders.order.noLogoSelected'),
  size = 80,
}) => {
  const getFileIcon = (fileName: string) => {
    const ext = fileName.split('.').pop()?.toLowerCase() || '';
    if (['png', 'jpg', 'jpeg'].includes(ext)) {
      return <ImageIcon fontSize='small' />;
    }
    return <FileIcon fontSize='small' />;
  };

  const isImage = attachment?.url && ['png', 'jpg', 'jpeg'].includes(
    attachment.name.split('.').pop()?.toLowerCase() || ''
  );

  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        bgcolor: isImage ? 'grey.50' : 'grey.200',
        padding: isImage ? 0 : 1,
        position: 'relative',
      }}
    >
      {isLoading ? (
        <CircularProgress size={24} />
      ) : isImage ? (
        <img
          src={attachment.url}
          alt={attachment.name}
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'contain',
            display: 'block',
          }}
        />
      ) : attachment ? (
        getFileIcon(attachment.name)
      ) : (
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            textAlign: 'center',
            fontSize: '0.7rem',
          }}
        >
          {noImageText}
        </Typography>
      )}
    </Box>
  );
};

export default AttachmentPreviewBox;